<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :title="$t('LP日志.日志明细')" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
                <!-- 列表为空时显示暂无数据 -->
                <div v-if="!list || list.length === 0" class="rounded-20 p-30 bg-white/10 mb-30 flex items-center justify-center">
                    <span class="text-28 text-#999">{{$t('我的LP.暂无数据')}}</span>
                </div>
				<div v-for="(item,index) in list" :key="index" class="rounded-20 p-30 bg-white/10 mb-30">
					<div class="flex items-center">
						<div class="ml-20 flex-1">
							<div class="flex items-center justify-between">
								<span class="text-28 text-white font-bold">{{item.value}} {{field_name}}</span>
							</div>
                            <div class="mt-10 flex items-center justify-between">
                                <span class="text-24 text-#999">{{item.type_name}}</span>
                                <span class="text-24 text-#999">{{item.created_at}}</span>
                            </div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="node"></menu-bar> -->
		</template>
		<template v-slot:popup>
			<van-popup v-model="showAmountPopup" position="center" round>
				<div class="w-690">
					<div class="flex items-center justify-center relative h-200">
						<img class="absolute w-200 h-200" style="z-index: 100;" src="@/assets/images/common/success.png"
							alt="" />
					</div>
					<div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30" style="margin-top: -98rem;">
						<div class="flex items-center justify-center mt-20">
							<span class="text-36 text-white">{{$t("我的LP.确认移除LP")}}</span>
						</div>
						<div class="flex items-center justify-center mt-20">
							<span class="text-26 text-#999">{{$t("我的LP.您即将移除LP并获得以下资产")}}</span>
						</div>
						<div class="rounded-18 bg-#1B1B1B  mt-20 mx-20 p-30">
							<div class="flex items-center justify-between">
								<span class="text-24 text-white">{{$t("我的LP.本金返还")}}</span>
								<span class="text-24 text-white">{{showItem.principal}} USDR</span>
							</div>
							<div class="mt-30 flex items-center justify-between pb-20 border-b border-b-solid" style="border-bottom-color: #454545;">
								<span class="text-24 text-white">{{$t("我的LP.收益")}}</span>
								<span class="text-24 text-primary">{{showItem.static}} ROON</span>
							</div>
							<div class="mt-20 flex items-center justify-between">
								<span class="text-24 text-white">{{$t("我的LP.总计")}}</span>
								<span class="text-24 text-success">{{showItem.principal}} USDR + {{showItem.static}} ROON</span>
							</div>
						</div>
						<div class="mt-40 flex items-center justify-center">
							<div @click="showAmountPopup = false"
								class="w-270 h-100 bg-white/10 rounded-full flex items-center justify-center mr-10">
								<span class="text-32 text-white">{{$t('弹窗.取消')}}</span>
							</div>
							<div @click="removeLiquidity"
								class="w-270 h-100 bg-primary rounded-full flex items-center justify-center ml-10">
								<span class="text-32 text-white">{{$t('我的LP.确认移除')}}</span>
							</div>
						</div>
					</div>
				</div>
			</van-popup>


            <van-popup v-model="againPopup" position="center" round>
                <div class="w-690">
                    <div class="flex items-center justify-center relative h-200">
                        <img class="absolute w-200 h-200" style="z-index: 100;" src="@/assets/images/common/success.png" alt="" />
                    </div>
                    <div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30" style="margin-top: -98rem;">
                        <div class="flex items-center justify-center mt-20">
                            <span class="text-36 text-white">{{$t('LP日志.确定复投LP')}}</span>
                        </div>

                        <div class="mt-40 flex items-center justify-center">
                            <div @click="againPopup = false"
                                 class="w-270 h-100 bg-white/10 rounded-full flex items-center justify-center mr-10">
                                <span class="text-32 text-white">{{$t('弹窗.取消')}}</span>
                            </div>
                            <div @click="again"
                                 class="w-270 h-100 bg-primary rounded-full flex items-center justify-center ml-10">
                                <span class="text-32 text-white">{{$t('LP日志.确定复投')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </van-popup>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
    import LiquidityManagementAbi from "@/abi/LiquidityManagementAbi"
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				typeList: [],
				queryInfo: {
					page: 1,
					type: 1
				},
				min_number: 0,
				node_allocate: 0,
				node_release: 0,
				node_low_pool: 1995,
				node_day: 0,
				node_number: 0,
				node_has: 0,
				node_price: 0,
				node_progress: 0,
				node_surplus_number: 0,
				last_pledge_id: 0,
				last_pledge_time: "",
                field: "",
                field_name: "USDR",
				all_surplus_roon: "",
				roon_number: "100000",
				node_name: "",
				rgt_swap: "",
				mining_contract: "",
				last_pledge_usdt: "",
				last_pledge_name: "",
				address: "",
				total_address: "",
				show_address: "",
				order_id: "",
				users_id: "",
                usdr_address: "0xbC75b416D9b4045BBF31d3F9DA7eD727aFCa2f79",
                lp_address: "0xC2271DB241ec1d95cDFD383F3F6375fCcE2436c0",
                wroon_address: "0xB142a57E25eF20De7A881ea22c10b11e47c0B1a0",
                FACTORY_ADDRESS:"0xf4516EFf9b8F046E86B64FD6956dce0928296856",
                ROUTER_ADDRESS:"0xa54d92bEd6455E43a09f6315fD050edFA9997306",
				contract_address: "0xf3708a77ea0282de751244194c304554d5a5d7ed",
				usdt_address: "0x55d398326f99059fF775485246999027B3197955",
				web3Provider: null,
				web3: null,
				list: [],
				amountList: [],
				showAmountPopup: false,
                againPopup: false,
				// 支付进行中的不可关闭 loading 遮罩
				paying: false,
				canGo: true,
				form: {
					type: 1,
					amount: 0,
					dd_roon: 0,
					amount_id: 0
				},
                showItem:{
                    id:0,
                    principal:0,
                    record_id:0,
                    static:0,
                },
				// 是否购买
				isBuy: true,
				numberList: [{
						id: 1,
						num: 100
					},
					{
						id: 2,
						num: 500
					},
					{
						id: 3,
						num: 1000
					},
					{
						id: 4,
						num: 2000
					},
					{
						id: 5,
						num: 5000
					},

				]
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
			activeType() {
				let item = {};
				item = this.typeList.find(item => item.id == this.queryInfo.type) || {};
				return item;
			},
			activeAmount() {
				let item = {};
				item = this.amountList.find(item => item.id == this.form.amount_id) || {};
				return item;
			}
		},
		created() {
			let vm = this
			getShowAddress()

			vm.getList();
		},
		methods: {
			async removeLiquidity(){

			},
            showYichu(item){
                let vm = this
                vm.showItem = item
                vm.showAmountPopup = true
            },
            showAgain(item){
                let vm = this
                vm.showItem = item
                vm.againPopup = true
            },
			goToLock() {
				this.$router.push({
					path: '/lock'
				})
			},
            again() {
                let vm = this
                ajaxData("/destroy/log",{
                    field:vm.field
                }).then(res => {
                    console.log(res)
                    vm.$message.success("操作成功")
                    vm.getList()
                    vm.againPopup = false
                })
            },
			getList() {
				let vm = this
				ajaxData("/destroy/log",{}).then(res => {
					console.log(res)
					vm.list = res.data.list;
				})
			},
			async getUserNodePurchaseStatus() {
				const vm = this;
				const contract = new vm.web3.eth.Contract(Mining_Abi, vm.mining_contract);
				let data = await contract.methods.getUserNodePurchaseStatus(vm.address).call();
				console.log(data)
				console.log(data.nodeCount)
			},
			handleInputTwo() {
				const vm = this;
				let val = String(vm.form?.amount ?? '');
				// 仅保留数字（不允许小数点与其他字符）
				val = val.replace(/\D/g, '');
				// 解析后的数值可能出现 NaN 的情况，需回退
				const parsed = parseInt(val, 10);
				if (!val.length || Number.isNaN(parsed) || !Number.isFinite(parsed)) {
					vm.form.amount = '';
					vm.form.dd_roon = 0;
					return;
				}
				vm.form.amount = parsed;
				vm.form.dd_roon = parsed / 20;
			},
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			selectAmount(number) {
				this.form.amount = parseInt(number);
				this.form.dd_roon = this.form.amount / 20;

				// this.form.amount_id = item.id;
				// this.showAmountPopup = false;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.swap-item1-bg-image {
		width: 690rem;
		height: 240rem;
		background-image: url("~@/assets/images/pages/swap/img_banner.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item2-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/swap/item1Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item3-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/swap/item2Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.bg-\#5ACC3C {
		background-color: #5ACC3C;
	}
</style>
